module.exports = __webpack_public_path__ + "img/office-2009-xianxiao.854ba288.jpg";